export const API_URL = "https://api.talentx.devision.co.kr";
// export const API_URL = "https://api.talentx.talentinum.com";
//export const API_URL = "https://api-dev.talentx.talentinum.com";
//export const API_URL = "http://localhost:8000";
